<template>
  <b-sidebar
    v-model="toggleSideBar"
    width="50%"
    id="sidebar-right"
    title="Users"
    backdrop-variant="dark"
    backdrop
    no-header
    right
    shadow
    @hidden="$emit('hidden')"
  >
    <template #default="{ hide }">
      <div
        class="d-flex text-light align-items-center px-3 py-2"
        style="background-color: #495057"
      >
        <strong class="mr-auto">Users</strong>
        <b-button size="sm" @click="$emit('hidden')">Close</b-button>
      </div>
      <div class="px-3 py-2">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row mb-2">
                  <div class="col-sm-8"></div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row form-group">
                      <label class="col-md-4 col-form-label">Employee ID</label>
                      <div class="col-md-8">
                        <input
                          v-model="filterUser.employee_id"
                          type="text"
                          placeholder="Employee ID"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-row form-group">
                      <label class="col-md-4 col-form-label">Name</label>
                      <div class="col-md-8">
                        <input
                          v-model="filterUser.name"
                          type="text"
                          placeholder="Name"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row form-group">
                      <label class="col-md-4 col-form-label">E-Mail</label>
                      <div class="col-md-8">
                        <input
                          v-model="filterUser.email"
                          type="text"
                          placeholder="E-Mail"
                          class="form-control"
                        />
                        <!-- onkeypress="return event.charCode >= 48 && event.charCode <= 57" -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-row form-group">
                      <label class="col-md-4 col-form-label">Open ID</label>
                      <div class="col-md-8">
                        <input
                          v-model="filterUser.open_id"
                          type="text"
                          placeholder="Open ID"
                          class="form-control"
                        />
                        <!-- onkeypress="return event.charCode >= 48 && event.charCode <= 57" -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-row form-group">
                      <label class="col-md-2 col-form-label">Status</label>
                      <div class="col-form-label row" style="margin-left: 0px">
                        <b-form-checkbox
                          @change="onUserSelectAllStatus($event)"
                          class="custom-checkbox custom-checkbox-outline custom-checkbox-info mb-3"
                          style="margin-right: 10px"
                          name="status_all"
                          id="status_all"
                          v-model="isUserSelectAllStatus"
                          >All</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-model="filterUser.status"
                          value="Active"
                          class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-3"
                          style="margin-right: 10px"
                          name="active"
                          id="active"
                          >Active</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-model="filterUser.status"
                          value="Inactive"
                          class="custom-checkbox custom-checkbox-outline custom-checkbox-danger mb-3"
                          style="margin-right: 10px"
                          name="inactive"
                          id="inactive"
                          >Inactive</b-form-checkbox
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-lg-12 text-sm-right">
                        <div class="button-items">
                          <button
                            type="button"
                            class="btn btn-primary waves-effect"
                            @click="onFilterUser()"
                          >
                            <i
                              class="bx bx-search font-size-16 align-middle mr-2"
                            ></i>
                            Search
                          </button>
                          <button
                            type="button"
                            class="btn btn-light waves-effect"
                            @click="onUserClear()"
                          >
                            <i
                              class="bx bx-reset font-size-16 align-middle mr-2"
                            ></i>
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" v-if="isPagingUser">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Size&nbsp;
                        <b-form-select
                          v-model="paginationUser.pageSize"
                          size="sm"
                          :options="pageOptions"
                          @change="onFilterUser()"
                        ></b-form-select
                        >&nbsp;Records
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          v-model="searchUser"
                          type="search"
                          :placeholder="`Search in page ${paginationUser.pageNo} `"
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="paginationUser.items && paginationUser.items.length > 0"
                >
                  <div class="col-lg-4">
                    <div style="position: relative; top: 7px">
                      Result
                      {{
                        (paginationUser.pageNo - 1) * paginationUser.pageSize +
                        1
                      }}
                      -
                      {{
                        paginationUser.pageNo * paginationUser.pageSize >
                        paginationUser.totalRecords
                          ? paginationUser.totalRecords
                          : paginationUser.pageNo * paginationUser.pageSize
                      }}
                      From {{ paginationUser.totalRecords }} Records
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <b-pagination
                      :total-rows="paginationUser.totalRecords"
                      :per-page="paginationUser.pageSize"
                      v-model="paginationUser.pageNo"
                      @change="onClickUserPagination($event)"
                      class="pagination pagination-rounded justify-content-end mb-2"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <b-table
                        class="table table-centered table-nowrap"
                        ref="usertable"
                        :empty-text="'Not found any result'"
                        :show-empty="!isPagingUser"
                        :bordered="true"
                        :filter="searchUser"
                        :filter-included-fields="['email']"
                        :items="formattedUsers"
                        align="center"
                        v-bind:fields="userTablefields"
                        :perPage="paginationUser.pageSize"
                      >
                        <template v-slot:cell(status)="data">
                          <b-badge
                            v-if="data.value === 'Active'"
                            variant="success"
                          >
                            {{ data.value }}
                          </b-badge>
                          <b-badge v-else variant="danger">
                            {{ data.value }}
                          </b-badge>
                        </template>
                        <template v-slot:cell(id)="data">
                          <div class="text-right">
                            <button
                              @click="onSelectedUserClick(data.item.id)"
                              type="button"
                              class="btn btn-success waves-effect waves-light"
                            >
                              Select user
                              <i class="fas fa-arrow-right"></i>
                            </button>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 text-sm-right">
                    <div class="button-items">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="hide"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <loading :active.sync="isLoading"></loading>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>
<script>
import Vue from "vue";
import Swal from "sweetalert2";
import userService from "@/helpers/service/user-provider";
import { eventBus } from "@/main.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  StatusEnum,
  ChannelAllowEnum,
  ChannelAllowTypeEnum,
} from "@/enum/group.enum.js";
import { userComputed, userMethods } from "@/state/helpers";

export default {
  props: {
    toggleSideBar: {
      type: Boolean,
      default: false,
    },
  },
  components: { Loading },
  data() {
    return {
      isLoading: false,
      toggle: false,
      filterUser: {
        open_id: "",
        employee_id: "",
        name: "",
        email: "",
        status: [],
      },
      searchUser: null,
      isUserSelectAllStatus: true,
      userSelectAllStatus: ["Active", "Inactive"],
      paginationUser: {
        totalRecords: 0,
        pageNo: 0,
        pageSize: 50,
        totalPages: 0,
        hasPreviousPage: true,
        hasNextPage: true,
        items: [],
      },
      pageOptions: [5, 10, 25, 50, 100],
      userTablefields: [
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          thStyle: "width:120px",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "id",
          label: "Select",
          thStyle: "width:80px",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...userComputed,
    isPagingUser() {
      return this.$validate.anyArrayObjectValid(this.paginationUser.items);
    },
    isPagingBottomUser() {
      return (
        this.$validate.anyArrayObjectValid(this.paginationUser.items) &&
        this.paginationUser.pageSize > 5 &&
        this.paginationUser.items.length > 5
      );
    },
    formattedUsers() {
      return this.paginationUser?.items?.map((user) => ({
        ...user,
        email: user.info.email, // Create a direct `email` field
      }));
    },
  },
  watch: {
    // toggleSideBar: function (val) {
    //   this.toggle = val;
    // },
    toggleSideBar(newVal) {
      console.log("newVal", newVal);
      this.filterUser.status = ["Active", "Inactive"];

      if (!newVal) {
        this.onUserClear();
        this.paginationUser.items = [];
        this.CLEAR_FILTER_USER();
      }
    },
    isUserSelectAllStatus: {
      handler(newVal) {
        if (newVal) {
          this.filterUser.status = ["Active", "Inactive"];
        }
      },
      immediate: true,
    },
    "filterUser.status": {
      handler() {
        this.isUserSelectAllStatus =
          this.filterUser.status.length === this.userSelectAllStatus.length
            ? true
            : false;
      },
      deep: true,
    },
    GET_FILTER_USER(val, oldVal) {
      this.filterUser = Object.assign({}, val);
    },
  },
  mounted: function () {
    console.log("filterUser", this.filterUser);

    // this.filterUser = Object.assign({}, this.GET_FILTER_USER);
  },
  methods: {
    ...userMethods,
    onUserSelectAllStatus(event) {
      this.filterUser.status = event ? this.userSelectAllStatus : [];
    },
    // async onFilterUser(pageNo = this.paginationUser.pageNo) {
    async onFilterUser(pageNo) {
      this.isLoading = true;

      let params = new URLSearchParams();
      params.append("pageSize", this.paginationUser.pageSize);
      // if (pageNo > 0) params.append("pageNo", this.paginationUser.pageNo);
      if (pageNo > 0) params.append("page", pageNo);

      params.append("open_id", this.filterUser.open_id.trim() || "");
      params.append("employee_id", this.filterUser.employee_id.trim() || "");
      params.append("name", this.filterUser.name.trim() || "");
      params.append("email", this.filterUser.email.trim() || "");

      if (!this.isUserSelectAllStatus) {
        this.filterUser.status.forEach((element) => {
          params.append("status", element);
        });
      }
      // this.filterUser.groups.forEach((element) => {
      //   params.append("groups", element);
      // });

      this.userSelected = [];
      this.usersDefaultSelected = [];
      let result = await userService.getUsersAsync(params);
      if (result.status === 200) {
        this.paginationUser = result.data;
        this.isLoading = false;

      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
      this.ADD_FILTER_USER(this.filterUser);
    },
    async onClickUserPagination(pageNo) {
      console.log("onClickUserPagination", pageNo);

      await this.onFilterUser(pageNo);
    },

    async onSelectedUserClick(userId) {
      this.$emit("setUserSelected", userId);
    },
    onUserClear() {
      this.filterUser = {
        open_id: "",
        employee_id: "",
        name: "",
        email: "",
        status: [],
      };
    },
  },
};
</script>
